import { AppConstants } from './../../shared/constants/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { PatientUrl } from '../../shared/urls/patient.url';
import { BaseService } from '../../shared/services/base.service';
import { ConsultationUrl } from '../../shared/urls/consultation.url';

@Injectable()
export class ViewUploadedDocumentsService {

  constructor(public baseService: BaseService) { }

  getAllConsultations() {
    return this.baseService.getAll(PatientUrl.PATIENT_GET_CONSULTATIONS);
  }

  getDocumentsByConsultationId(consultationId: string): Observable<any> {
    const url = ConsultationUrl.GET_CONSULTATION_ATTACHMENT_SHARED.replace("{id}", consultationId);
    return this.baseService.getAll(url);
  }

  addAuditTrail(param) {
    const url = PatientUrl.PATIENT_ADD_AUDIT_TRAIL;
    return this.baseService.postData(url, param);
  }

  downloadFile(id){
    const url = PatientUrl.PATIENT_DOWNLOAD_ATTACHMENT + '?id='+id;
    return this.baseService.downloadFile(url);
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-uploaded-documents/view-uploaded-documents.service.ts